import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgServerless = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-serverless';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M10.92 7.661a927 927 0 0 0-3.033 5.058c-.009.028.931.041 2.85.041 1.575 0 2.863.009 2.863.021 0 .011-.83 1.771-1.844 3.91l-1.864 3.938c-.013.033.215.163.65.371.369.176.677.314.685.307.007-.008 1.083-2.272 2.391-5.031l2.377-5.016-2.73-.02-2.73-.02 2.352-3.9a537 537 0 0 0 2.352-3.92c.001-.028-1.223-.761-1.265-.758-.019.001-1.393 2.26-3.054 5.019M4.548 9.247C3.146 10.745 2 11.984 2 12s1.146 1.255 2.548 2.753l2.547 2.724.223-.207.548-.512.326-.306-2.075-2.216A172 172 0 0 1 4.043 12c0-.011.932-1.017 2.073-2.234l2.073-2.215-.325-.308c-.178-.169-.424-.4-.546-.514l-.223-.206zm11.821-2.226c-.292.273-.533.508-.535.523-.003.014.92 1.015 2.051 2.224a201 201 0 0 1 2.064 2.225c.004.015-.925 1.024-2.066 2.243l-2.075 2.216.326.306.548.512.223.207 2.547-2.724C20.854 13.255 22 12.016 22 12c0-.023-4.604-4.972-4.994-5.368l-.106-.108z"
    })
  }));
});
export default SvgServerless;